/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black" :to="{ name: 'managemenu' , params: {brandPath: this.$route.params.brandPath}} "><p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">チェック内容設定画面</p>
                </div>
            </div>
        </div>
        <CheckSettingList/>
    </div>
</template>

<script>
    import CheckSettingList from '@/app/components/CheckSettingList.vue'
    export default {
        name: 'manageCheckMenuList',
        components: {
            CheckSettingList
        }
    }
</script>
